export const state = {
  nature: undefined,
  natures: [],
  sousNature: undefined,
  sousNatures: []
}